document.addEventListener('DOMContentLoaded', (event) => {
  const inputEmail = document.querySelector('.js-newsletter-email-input')
  const submitEmailButton = document.querySelector('.js-newsletter-submit')

  const emailErrorMessage = document.querySelector('.js-newsletter-error')

  const form = document.querySelector('#footer_newsletter_email')

  let waitingEmailSubmit = false

  function submitClicked() {
    if (waitingEmailSubmit) return
    emailErrorMessage.classList.add('hidden')
    waitingEmailSubmit = true
    form.submit()
  }

  function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  submitEmailButton.addEventListener('click', (e) => {
    e.preventDefault()
    const checkbox = form?.querySelector('input[type="checkbox"]') ?? null
    if (checkbox && !checkbox.checked && !inputEmail.value) {
      emailErrorMessage.innerText = window.errorStrings.emptyEmailAndCheckbox
      emailErrorMessage.classList.remove('hidden')
    } else if (
      checkbox &&
      !checkbox.checked &&
      !validateEmail(inputEmail.value)
    ) {
      emailErrorMessage.innerText = window.errorStrings.invalidEmailAndCheckbox
      emailErrorMessage.classList.remove('hidden')
    } else if (checkbox && !checkbox.checked) {
      emailErrorMessage.innerText = window.errorStrings.emptyCheckbox
      emailErrorMessage.classList.remove('hidden')
    } else if (!inputEmail.value) {
      emailErrorMessage.innerText = window.errorStrings.emptyEmail
      emailErrorMessage.classList.remove('hidden')
    } else if (!validateEmail(inputEmail.value)) {
      emailErrorMessage.innerText = window.errorStrings.invalidEmail
      emailErrorMessage.classList.remove('hidden')
    } else {
      emailErrorMessage.classList.add('hidden')
      submitClicked('email')
    }
  })
})
